import { render, staticRenderFns } from "./containerFee.vue?vue&type=template&id=ec0e6224&scoped=true"
import script from "./containerFee.vue?vue&type=script&lang=js"
export * from "./containerFee.vue?vue&type=script&lang=js"
import style0 from "./containerFee.vue?vue&type=style&index=0&id=ec0e6224&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0e6224",
  null
  
)

export default component.exports